import { gql } from '@apollo/client';

/**
 * GraphQL mutation for creating a new community group
 */
export const CREATE_COMMUNITY_GROUP = gql`
  mutation CreateCommunityGroup($input: CreateCommunityGroupInput!) {
    createCommunityGroup(input: $input) {
      id
      name
      description
      securityGroups {
        admin
        moderator
        user
      }
    }
  }
`;
